import type { FaireProductEntity } from "../../entity_types/product";

export const p_f85469chkb: FaireProductEntity = {
  token: "p_f85469chkb",
  type: "product",
  name: "Olive Catch-all Tray",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/2f30cc9b29f18ed141bbb9871979c0280ad31386ddd78c4090f89d36dd22e2c3.png",
  galleryImageUrls: [],
  priceDollars: 8,
  description: "A vibrant metal tray perfect for trinkets, snacks, and more!\n\nA catch all for your desk and a perfect way to proudly display your olive sticky notes and stationery. \n\nGood to know:\n-Measures 7\"x5.5\"\n-Durable metal tray\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:58.800Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
